import { render, staticRenderFns } from "./BulkActionTagManager.vue?vue&type=template&id=258011c2&"
import script from "./BulkActionTagManager.vue?vue&type=script&lang=js&"
export * from "./BulkActionTagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports